import {Stack} from '@treatwell/ui';
import styles from './VenueCardSkeleton.module.css';
import clsx from 'clsx';

export const VenueCardSkeleton = () => {
  return (
    <div className={styles.root}>
      <div className={styles.image}></div>
      <Stack space="md" className={styles.content}>
        <div className={clsx(styles.line, styles.line1)}></div>
        <div className={clsx(styles.line, styles.line2)}></div>
        <div className={clsx(styles.line, styles.line3)}></div>
      </Stack>
    </div>
  );
};
